<template>
  <WarrantsDataTableTab
    :headers="headers"
    error-title="Failed to load communication groups"
    data-testid="warrants-comm-groups"
    row-clickable
    :fetcher="fetchGroups"
    :items-from="itemsFrom"
    @row-click="onRowClick"
  >
    <template #[`item.status`]="{ internalItem }">
      <SoChip :text="internalItem.raw.statusDisplay" size="small" />
    </template>
  </WarrantsDataTableTab>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import WarrantsDataTableTab from "@/views/admin/warrants/components/WarrantsDataTableTab.vue"
  import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
  import { SoDataTableHeader } from "@/types/components/SoDataTable"
  import {
    createdAtColumn,
    deletedColumn,
    idColumn,
    statusColumn,
  } from "@/views/admin/warrants/warrantsColumns"
  import {
    WarrantsCommunicationGroupListResult,
    WarrantsCommunicationGroupService,
  } from "@/services/admin/WarrantsCommunicationGroupService"
  import { IWarrantsCommunicationGroup } from "@/models/admin/warrantsCommunicationGroup/warrantsCommunicationGroup.types"
  import { RouteNames } from "@/types/router"

  const headers: SoDataTableHeader[] = [
    idColumn,
    statusColumn,
    {
      title: "Parent Status",
      key: "parentStatusDisplay",
      sortable: true,
      sortKey: "parent_status",
    },
    {
      title: "Priority",
      key: "currentPriorityLevel",
      sortable: true,
      sortKey: "current_priority_level",
    },
    {
      title: "Error",
      key: "errorDescription",
      sortable: false,
      fallbackValue: "—",
    },
    createdAtColumn,
    deletedColumn,
  ]

  export default defineComponent({
    components: {
      SoChip,
      WarrantsDataTableTab,
    },
    data() {
      return {
        headers,
      }
    },
    computed: {
      accountNumber(): string {
        return this.$route.params.accountNumber as string
      },
    },
    methods: {
      fetchGroups({ page, pageSize, orderBy }: SoDataTableOptions) {
        return WarrantsCommunicationGroupService.getGroups(
          this.accountNumber,
          page,
          pageSize,
          orderBy,
        )
      },
      itemsFrom(result: WarrantsCommunicationGroupListResult) {
        return result.groups
      },
      onRowClick(group: IWarrantsCommunicationGroup) {
        this.$router.push({
          name: RouteNames.AdminServiceWarrantsCommunicationGroup,
          params: {
            serviceName: this.$route.params.serviceName,
            accountNumber: this.accountNumber,
            groupId: String(group.id),
          },
        })
      },
    },
  })
</script>
